__webpack_require__.p = "/Social-Network-Columbia-Barnard/";